import { getAll } from '@/api/tiers';
import store from '@/store/store';
import {
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE, TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export default async function getBailleurs(bailleurs) {
  const bailleursFiltered = [...new Set(bailleurs)];
  if (bailleursFiltered.length === 0) return [];

  const bailleursApi = (await getAll({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      type: TIERS_TYPE_FOURNISSEUR,
      archive: false,
      sousType: [
        TIERS_SOUS_TYPE_BAILLEUR_PRO,
        TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
        TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
        TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
      ],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  const errors = [];
  bailleursFiltered.forEach((bailleur) => {
    const isInResult = bailleursApi.find((b) => {
      return b.referenceExterne === bailleur.toString();
    });
    if (!isInResult) {
      errors.push({
        message: 'importDonne.dataNotExist',
        parametres: { data: bailleur },
      });
    }
  });
  if (errors.length > 0) throw errors;

  return bailleursApi;
}
